<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import FileBox from '../common/FileBox.vue'
import CheckMoreText from '../common/CheckMoreText.vue'

import { getPageThemeColor } from '@/utils/modules/getStyles'
import { textLenHandler, filtersRichtext } from '@/utils/common.js'

export default {
  name: 'Comp24',
  components: { ModuleTitle, FileBox, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getPageThemeColor, textLenHandler, filtersRichtext }
}
</script>

<template>
  <div class="modules-id-24">
    <module-title :title="moduleOption.title" margin-bottom="40" />
    <div class="comp-transverse-2 modules-id-24-content pointer">
      <div v-for="(v, i) in moduleOption.list.slice(0, 4)" :key="`modules-24-${i}`">
        <div v-if="v.typeid === 1 || v.typeid === 0" class="intro-content">
          <p class="intro-text h-line-3">{{ v.memo && textLenHandler(filtersRichtext(v.memo), 60) }}</p>
          <check-more-text />
        </div>
        <file-box v-else :headline="v.headline" :filename="v.typename" :createtime="v.createtime" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-24-content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  row-gap: 80px;
  column-gap: 24px;
  .intro-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 91px;
    .intro-text {
      width: 340px;
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 22px;
      text-indent: 2em;
    }
    .check-more-text {
      font-size: 13px;
      font-weight: bold;
      i {
        font-weight: bold;
      }
    }
  }
}
</style>
